// extracted by mini-css-extract-plugin
export var box = "ConsentItem-module--box--fabc6";
export var box_md = "ConsentItem-module--box_md--585e2";
export var box_xmd = "ConsentItem-module--box_xmd--a216e";
export var box_flex = "ConsentItem-module--box_flex--4f447";
export var box_lg = "ConsentItem-module--box_lg--27129";
export var box_sm = "ConsentItem-module--box_sm--00fa5";
export var box_outer = "ConsentItem-module--box_outer--efd7b";
export var box_whiteBg = "ConsentItem-module--box_white-bg--51444";
export var box_noMarginBottom = "ConsentItem-module--box_no-margin-bottom--fa434";
export var box_noPadding = "ConsentItem-module--box_no-padding--e2c01";
export var box_outerGray = "ConsentItem-module--box_outer-gray--a9461";
export var box_dark = "ConsentItem-module--box_dark--952ad";
export var box_zIndex = "ConsentItem-module--box_z-index--37a4b";
export var box_zIndex6 = "ConsentItem-module--box_z-index-6--495ad";
export var box_eventsWithLine = "ConsentItem-module--box_events-with-line--25242";
export var box_featuresAo = "ConsentItem-module--box_features-ao--978eb";
export var box_verticalPaddings = "ConsentItem-module--box_vertical-paddings--55bad";
export var clearP = "ConsentItem-module--clearP--421e1";
export var clearP_vc = "ConsentItem-module--clearP_vc--937a5";
export var panelWrapper = "ConsentItem-module--panelWrapper--155d1";
export var panel = "ConsentItem-module--panel--71708";
export var description = "ConsentItem-module--description--7e6ea";
export var active = "ConsentItem-module--active--bea68";
export var title = "ConsentItem-module--title--8b19a";
export var panelContentWrapper = "ConsentItem-module--panelContentWrapper--27f9e";
export var replaceText = "ConsentItem-module--replaceText--09ddd";
export var fadeInAnimation = "ConsentItem-module--fadeInAnimation--3a007";
export var placeHolderShimmer = "ConsentItem-module--placeHolderShimmer--cf6bd";